<template>
  <v-btn
    rounded
    :small="!isMobile()"
    height="30"
    color="info"
    depressed
    :block="isMobile()"
    @click="addExperiencia()"    
    ><v-icon left>mdi-plus</v-icon>Adicionar experiência
  </v-btn>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations(["setDialogManutExpProf", "resetStateExpProf"]),    
    isMobile() {
      return this.$mq == "sm";
    },
    addExperiencia(){
      this.resetStateExpProf()
      this.setDialogManutExpProf(true)
    }
  },
};
</script>

<style>
</style>